import React, { useState, useEffect, useRef } from "react";
import PopUp from "../Components/PopUp/PopUp";
import {
  Globe,
  Zap,
  Clock,
  Bot,
  CalendarCheck,
  Sparkles,
  Circle,
  CheckCircle2,
  Play,
  ArrowRight,
  Gift,
  Phone,
  Lock,
  CreditCard,
  ShieldCheck,
  Check,
  AlertTriangle,
  Timer,
  Trash2,
  Edit3,
  Mic,
} from "lucide-react";
import "./QuickAgent2.css";
import {
  getAgentDetails,
  createWidgetWebCall,
  createQuickAgentPayment,
  SubmitKnowledgeBase,
  updateAgent,
  validateWebsite,
  listSiteMap,
} from "../lib/Store";
import { RetellWebClient } from "retell-client-js-sdk";
import GmbAutocomplete from "../Components/GmbAutocomplete/GmbAutocomplete";
import { useParams, useNavigate } from "react-router-dom";
import useDebounce from "../hook/useDebounce";
import filterCompanyPages from "../lib/filterCompanyPages";
// import Loader from "../Components/ButtonLoader/Loader";
import Alert from "../Components/Alert/Alert";
import { businessServices } from "../lib/businessServices";
import Loader from "../Components/Loader/Loader";
const domainComplete = (url) => {
  return /\.[a-z]{2,}$/i.test(url);
};
export const businessCategoryTypes = [
  "Real Estate Broker",
  "Restaurant",
  "Interior Designer",
  "Salon",
  "Landscaping Company",
  "Dentist",
  "Doctor's Clinic",
  "Gym & Fitness Center",
  "Personal Trainer",
  "Web Design Agency",
  "Architect",
  "Property Rental & Leasing Service",
  "Construction Services",
  "Insurance Agency",
  "Old Age Home",
  "Travel Agency",
  "Ticket Booking",
  "Accounting Services",
  "Financial Planners",
  "Beauty Parlour",
  "Nail Salon",
  "Barber Studio/Shop",
  "Hair Stylist",
  "Bakery",
  "Dry Cleaners",
  "Cleaning and Janitorial Services",
  "Tour Guides",
  "Deli Shop",
  "Marketing Agency",
  "Digital Marketing Agency",
  "Car Repair & Garage",
  "Boat Repair",
  "Car & Bus Services",
  "Taxi, Cab & Limo Booking",
  "Movers and Packers",
  "Trucking Company",
  "Spa & Wellness Center",
  "Print Shop",
  "School",
  "Colleges & Universities",
  "Training Center",
  "Educational Institute",
  "Plumber",
  "Other",
];
export default function QuickAgentSetup2() {
  const { agentId } = useParams();
  const navigate = useNavigate();
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [currentStep, setCurrentStep] = useState("unclaimed");
  const [websiteUrl, setWebsiteUrl] = useState("joesplumbing.com");
  const [isFromAgent, setIsFromAgent] = useState(false);
  const [agentName, setAgentName] = useState(null);
  const [agentAccent, setagentAccent] = useState(null);
  const [businessName, setbusinessName] = useState(null);
  const [isValidAgent, setIsValidAgent] = useState(false);
  const [checkingAgent, setCheckingAgent] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [onCall, setOnCall] = useState(false);
  const [callLabel, setCallLabel] = useState("Call REX");
  const [callStatusText, setCallStatusText] = useState("Ready");
  const [phoneIcon, setPhoneIcon] = useState("/Svg/Phone-call.svg");
  const [agentIds, setAgentId] = useState(null);
  const [avatorUrl, setavatarUrl] = useState(null);
  const retellWebClientRef = useRef(null);
  const [isActivating, setIsActivating] = useState(false);
  const [userId, setuserId] = useState(null);
  const [isCalling, setIsCalling] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [agentRole, setagentRole] = useState(null);
  const [noGmb, setNoGmb] = useState(false);
  const [placeDetails, setPlaceDetails] = useState(null);
  // console.log(placeDetails, "placeDetails")
  const [address, setAddress] = useState([])
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  // console.log(address, "address")
  const [kbForm, setKbForm] = useState({
    fullName: "",
    email: "",
    website: "",
    gmbLink: "",
    category: "",
  });

  const extractAddressFields = (addressComponents) => {
    const getComponent = (
      primaryType,
      fallbackType = null,
      useShort = false
    ) => {
      const comp = addressComponents.find(
        (c) =>
          c.types.includes(primaryType) ||
          (fallbackType && c.types.includes(fallbackType))
      );
      return comp ? (useShort ? comp.short_name : comp.long_name) : "";
    };

    return {
      city: getComponent("locality", "sublocality_level_1"),
      state: getComponent("administrative_area_level_1"),
      state_code: getComponent("administrative_area_level_1", null, true),
      country: getComponent("country"),
      country_code: getComponent("country", null, true),
      postal_code: getComponent("postal_code"),
      street_number: getComponent("street_number"),
      route: getComponent("route"),
    };
  };
  // console.log(kbForm, "kbForm")
  const [ventryUrl, setventryUrl] = useState(null);
  const [kbLoading, setKbLoading] = useState(false);
  const [kbErrors, setKbErrors] = useState({
    fullName: "",
    email: "",
  });
  const [businessCity, setbusinessCity] = useState(null);
  const [businessState, setbusinessState] = useState(null);
  const [websiteValidating, setWebsiteValidating] = useState(false);
  const [websiteValidated, setWebsiteValidated] = useState(false);
  const [websiteTouched, setWebsiteTouched] = useState(false);
  const [siteMapUrls, setSiteMapUrls] = useState([])
  // console.log(siteMapUrls, "siteMapUrls")
  // add this line
  const [kbError, setKbError] = useState(null);

  const [kbSuccess, setKbSuccess] = useState(false);

  useEffect(() => {
    retellWebClientRef.current = new RetellWebClient();
  }, []);

  const [agentExpireAt, setAgentExpireAt] = useState(null);
  const [country_code, setcountry_code] = useState(null);

  useEffect(() => {
    if (!isValidAgent || !agentId) return;

    const STORAGE_KEY = `agent-delete-expiry-${agentId}`;
    const twentyFourHoursMs = 24 * 60 * 60 * 1000;
    const now = Date.now();

    let stored = localStorage.getItem(STORAGE_KEY);
    let expiry = stored ? parseInt(stored, 10) : NaN;

    if (!stored || Number.isNaN(expiry) || expiry < now) {
      expiry = now + twentyFourHoursMs;
      localStorage.setItem(STORAGE_KEY, expiry.toString());
    }

    setAgentExpireAt(expiry);
    const diffSec = Math.floor((expiry - now) / 1000);
    setTimeLeft(diffSec > 0 ? diffSec : 0);
  }, [isValidAgent, agentId]);
  const verifyAndFetchAgent = async () => {
    try {
      if (!agentId) {
        navigate("/");
        return;
      }
      const data = await getAgentDetails(agentId);
      // if (data?.error === "Quick setup link expired") {
      //   navigate("/");
      //   return;
      // }
      const { agent, business, userDetails } = data || {};
      const {
        ventryUrl,
        agentExpireTime,
        agentName,
        agentAccent,
        agent_id: apiAgentId,
        avatar,
        userId,
        agentRole,
      } = agent || {};
      const {
        name, email
      } = userDetails || {};

      setKbForm((prev) => ({
        ...prev, fullName: name,
        email: email
      }))
      // console.log(ventryUrl, "ventryUrl");
      const webUrl =
        business?.webUrl || business?.knowledge_base_texts?.website;

      const businessName = business?.businessName;
      const businessCityy = business?.city;
      const businessState = business?.state;
      const country = business?.country_code;
      if (!ventryUrl || String(ventryUrl) !== String(agentId)) {
        navigate("/");
        return;
      }
      if (agentExpireTime == 0) {
        navigate("/");
      }
      if (!agentExpireTime || Number(agentExpireTime) === 0) {
        navigate("/");
        return;
      }
      let expiryMs;
      const expNum = Number(agentExpireTime);

      if (Number.isNaN(expNum)) {
        navigate("/");
        return;
      }
      if (String(expNum).length === 13) {
        expiryMs = expNum;
      } else {
        expiryMs = expNum * 1000;
      }

      const now = Date.now();
      if (expiryMs <= now) {
        navigate("/");
        return;
      }
      setAgentExpireAt(expiryMs);
      const diffSec = Math.floor((expiryMs - now) / 1000);
      setTimeLeft(diffSec > 0 ? diffSec : 0);
      if (webUrl) {
        setWebsiteUrl(webUrl);
        setIsFromAgent(true);
      }
      if (agentName) {
        setAgentName(agentName);
      }
      if (agentAccent) {
        setagentAccent(agentAccent);
      }
      if (apiAgentId) {
        setAgentId(apiAgentId);
      }
      if (businessName) {
        setbusinessName(businessName);
      }
      if (avatar) {
        setavatarUrl(avatar);
      }
      if (businessCityy) {
        setbusinessCity(businessCityy);
      }
      if (businessState) {
        setbusinessState(businessState);
      }
      if (country) {
        setcountry_code(country);
      }

      if (userId) {
        setuserId(userId);
      }
      if (agentRole) {
        setagentRole(agentRole);
      }
      if (ventryUrl) {
        setventryUrl(ventryUrl);
      }
      setIsValidAgent(true);
    } catch (err) {
      console.error("Error fetching agent details:", err);
      // navigate('/');
    } finally {
      setCheckingAgent(false);
    }
  };
  useEffect(() => {
    verifyAndFetchAgent();
  }, [agentId, navigate]);

  const validateKbForm = () => {
    const errors = {};
    const trimmedName = kbForm.fullName.trim();
    const trimmedEmail = kbForm.email.trim();

    if (!trimmedName) {
      errors.fullName = "Full name is required.";
    } else if (trimmedName.length > 50) {
      errors.fullName = "Full name must be at most 50 characters.";
    } else if (!/^[A-Za-z\s]+$/.test(trimmedName)) {
      errors.fullName = "Full name can only contain letters and spaces.";
    }

    if (!trimmedEmail) {
      errors.email = "Email is required.";
    } else if (trimmedEmail.length > 60) {
      errors.email = "Email must be at most 60 characters.";
    } else if (/\s/.test(trimmedEmail)) {
      errors.email = "Email cannot contain spaces.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      errors.email = "Enter a valid email address.";
    }

    return errors;
  }
  const handleKnowledgeBaseSubmit = async (e) => {
    e.preventDefault();

    // Reset errors & success
    setKbError(null);
    setKbSuccess(false);

    // 1 Form validation
    const errors = validateKbForm();
    if (Object.keys(errors).length > 0) {
      setKbErrors(errors);
      return;
    }

    setKbLoading(true);

    try {
      let servicesArray = [];
      if (kbForm.category) {
        const matched = businessServices.find(
          (item) => item.type === kbForm.category
        );

        servicesArray = matched
          ? matched.services
            .map((item) =>
              typeof item === "string" ? item : item.service
            )
            .filter((service) => service !== "Other")
          : [];
      }
      // 2 Submit Knowledge Base
      await SubmitKnowledgeBase({
        fullName: kbForm.fullName.trim(),
        email: kbForm.email.trim(),
        website: kbForm.website,
        googleMyBusiness: kbForm.gmbLink,
        businessCategory: kbForm.category,
      });
      const fetchUrlsMap = siteMapUrls ? siteMapUrls.map((urls) => urls.url) : []
      // 3 Prepare payload for agent update
      const agentPayload = {
        agentId: agentIds,
        userId: userId,
        email: kbForm.email.trim(),
        name: kbForm.fullName.trim(),
        industry: kbForm.category,
        service: [],
        businessName: placeDetails?.businessName || "",
        businessWebsite: placeDetails?.website || "",
        businessPhone: placeDetails?.phone || "",
        businessEmail: "",
        businessTimezone: "",
        timeZoneId: "",
        businessAddress: {
          addressDetails: {
            businessName: placeDetails?.businessName || "",
            streetAddress: address?.route || "",
            locality: address?.city || "",
            city: address?.city || "",
            district: address?.city || "",
            state: address?.state || "",
            country: address?.country || "",
            postalCode: address?.postal_code || "",
            formattedAddress: placeDetails?.address || "",
            country_code: address.country_code
          },
        },
        country_code: address.country_code,
        state_code: address.state_code,
        googleBusinessName: placeDetails?.businessName || "",
        googleListing: kbForm.gmbLink || "",
        sitemapUrls: JSON.stringify(fetchUrlsMap) || [],
        selectedSitemapUrls: JSON.stringify(siteMapUrls) || [],
        knowledge_base_texts_Details: JSON.stringify(placeDetails),
        service: servicesArray
      };

      // 4 Update Agent
      const res = await updateAgent(agentPayload);
      // 5 Handle response
      if (res?.data?.success) {
        setPopupType("success");
        setPopupMessage("Knowledge base updated successfully!");
        setShowPopup(true);
        setKbSuccess(true);
        setShowPopup(true);
        verifyAndFetchAgent()
        setKbForm([])
        setWebsiteValidating(false)
        setWebsiteValidated(false)
        setWebsiteTouched(false)
        setKbError(false);
        setKbSuccess(false)
        setKbError("");
        setTimeout(() => {
          setShowPopup(false);
          setOpenEditPopup(false);
        }, 1000);
        // setPopupMessage("")
      } else {
        const message = res.response.data.message || res.response.data.message || "Something went wrong";
        setKbError(true);
        setKbError(message);
      }
    } catch (err) {
      // 6Catch network or API errors
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "An unexpected error occurred";
      setKbError(message);
      console.error("KB Submit Error:", err);
    } finally {
      setKbLoading(false);
    }
  };


  useEffect(() => {
    if (currentStep !== "unclaimed") return;
    if (!agentExpireAt) return;

    const tick = () => {
      const now = Date.now();
      const diffMs = agentExpireAt - now;

      if (diffMs <= 0) {
        setTimeLeft(0);
        navigate("/");
        return;
      }

      const diffSec = Math.floor(diffMs / 1000);
      setTimeLeft(diffSec);
    };
    tick();

    const timerId = setInterval(tick, 1000);

    return () => clearInterval(timerId);
  }, [currentStep, agentExpireAt, navigate]);

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, "0")}:${m
      .toString()
      .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  const switchStep = (step) => {
    setCurrentStep(step);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleTestCall = async () => {
    if (buttonDisabled) return;
    if (onCall) {
      try {
        setButtonDisabled(true);
        if (retellWebClientRef.current) {
          await retellWebClientRef.current.stopCall();
        }
        setOnCall(false);
        setIsCalling(false);
        setCallLabel("Call REX");
        setCallStatusText("Call ended");
        setPhoneIcon("/Svg/Phone-call.svg");
      } catch (err) {
        console.error("Error ending call:", err);
        setCallStatusText("Failed to end call");
      } finally {
        setButtonDisabled(false);
      }
      return;
    }
    if (!agentIds) {
      console.error("Agent ID missing, cannot start call");
      alert("Agent not ready yet. Please try again in a moment.");
      return;
    }
    setButtonDisabled(true);
    try {
      if (navigator?.mediaDevices?.getUserMedia) {
        try {
          await navigator.mediaDevices.getUserMedia({ audio: true });
        } catch (err) {
          console.error("Microphone error:", err);
          alert("Please allow microphone access to make call.");
          setButtonDisabled(false);
          return;
        }
      }
      setOnCall(true);
      setIsCalling(true);
      setCallLabel("Calling...");
      setCallStatusText("Connecting...");
      setPhoneIcon("/Svg/Hangup.svg");
      const data = await createWidgetWebCall(agentIds);
      if (data?.access_token && data?.call_id) {
        if (retellWebClientRef.current) {
          await retellWebClientRef.current.startCall({
            accessToken: data.access_token,
          });
        }
        setCallStatusText(`In Call with ${agentName || "agent"}`);
        setCallLabel("Connected");
      } else {
        setCallStatusText("Unable to start call");
        setCallLabel("Call REX");
        setPhoneIcon("/Svg/Phone-call.svg");
        setOnCall(false);
        setIsCalling(false);
      }
    } catch (err) {
      console.error("Call failed:", err);
      setCallStatusText("Call failed");
      setCallLabel("Call REX");
      setPhoneIcon("/Svg/Phone-call.svg");
      setOnCall(false);
      setIsCalling(false);
    } finally {
      setButtonDisabled(false);
    }
  };

  const handleClaimAgent = async () => {
    if (isActivating) return;
    setIsActivating(true);
    try {
      const res = await createQuickAgentPayment(
        agentIds,
        userId,
        "price_1RcCWpSCQQfKS3WDnyGZU5LA",
        agentName,
        businessName,
        ventryUrl
      );
      const checkoutUrl = res?.data?.checkoutUrl || res?.checkoutUrl;
      if (checkoutUrl) {
        window.open(checkoutUrl, "_self");
      }
    } catch (err) {
      console.error("Failed to start free trial:", err);
      alert(
        "Something went wrong while starting free trial. Please try again."
      );
    } finally {
      setIsActivating(false);
    }
  };
  const handleKbFieldChange = (field) => (e) => {
    const value = e.target.value;

    setKbForm((prev) => ({
      ...prev,
      [field]: value,
    }));

    setKbErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };
  //fetch google listing details 
  const fetchPlaceDetails = (place) => {

    const placeId = place.placeId
    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );
    service.getDetails(
      {
        placeId,
        fields: [
          "place_id",
          "name",
          "url",
          "website",
          "formatted_address",
          "international_phone_number",
          "formatted_phone_number",
          "opening_hours",
          "rating",
          "user_ratings_total",
          "business_status",
          "types",
          "address_components",
        ],
      },
      (result, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {

          const addressFields = extractAddressFields(result.address_components)
          setAddress(addressFields)
          // console.log(addressFields,"addressFields")
          const businessData = {
            businessName: result.name || "",
            address: result.formatted_address || "",
            phone:
              result.international_phone_number ||
              result.formatted_phone_number ||
              "",
            internationalPhone: result.international_phone_number || "",
            website: result.website || "",
            rating: result.rating || "",
            totalRatings: result.user_ratings_total || "",
            hours: result.opening_hours?.weekday_text || [],
            businessStatus: result.business_status || "",
            categories: result.types || [],
            address_components: result.address_components || [],
          };

          setPlaceDetails(businessData);
        } else {
          console.error("Place details fetch failed:", status);
        }

      }
    );
  };

  const debouncedWebsite = useDebounce(kbForm.website, 600);
  useEffect(() => {
    // If website is empty → clear everything and stop
    if (!debouncedWebsite || debouncedWebsite.trim() === "") {
      setWebsiteValidating(false);
      setWebsiteValidated(false);
      setSiteMapUrls([]);  // clear sitemap URLs
      return;
    }

    // avoid calling API on partial input
    const domainPattern = /\.[a-z]{2,}$/i;
    if (!domainPattern.test(debouncedWebsite)) return;

    const checkWebsite = async () => {
      setWebsiteValidating(true);

      const result = await validateWebsite(debouncedWebsite);

      if (!result || !result.valid) {
        setWebsiteValidating(false);
        setWebsiteValidated(false);
        setSiteMapUrls([]);
        return;
      }

      // If website validated → get sitemap
      const res = await listSiteMap(debouncedWebsite);
      const filtered = await filterCompanyPages(res.urls);

      setSiteMapUrls(filtered);
      setWebsiteValidated(true);
      setWebsiteValidating(false);
    };

    checkWebsite();
  }, [debouncedWebsite]);

   if (checkingAgent) {
    return (
      <>
        <Loader />
      </>
    );
  }
  return (
    <>
      <div className="container">
        {/* NAVBAR */}
        <nav className="navbar">
          <div className="navInner">
            <div className="logoArea">
              <img
                src="/Svg/rexpt-logo.svg"
                alt="Rexpt Logo"
                className="logoImage"
              />
            </div>

            {currentStep === "unclaimed" && (
              <div className="statusBadge">
                <span className="pulseDot"></span>
                <span className="hidden sm:inline">Status: </span> Pending
                Deletion
              </div>
            )}
          </div>
        </nav>

        {/* MAIN CONTENT */}
        <main className="main">
          {/* STEP 1: UNCLAIMED ASSET DASHBOARD */}
          {currentStep === "unclaimed" && (
            <div className="dashboardContainer">
              {/* URGENCY BANNER */}
              <div className="urgencyBanner">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                  }}
                >
                  <div className="bannerIcon">
                    <Trash2 size={32} color="white" />
                  </div>
                  <div className="bannerText">
                    <h3>Unclaimed Agent Detected</h3>
                    <p>This pre-trained agent will be deleted in:</p>
                  </div>
                </div>
                <div className="timerBox">{formatTime(timeLeft)}</div>
              </div>

              {/* AGENT CARD */}
              <div className="agentCard">
                {/* Left: Preview */}
                <div className="agentPreview">
                  <div className="profileHeader">
                    <div className="avatarWrapper">
                      <div className="avatar">
                        <Bot size={28} />
                      </div>
                      <div className="liveIndicator"></div>
                    </div>
                    <div>
                      <h2 className="businessTitle">{agentName}</h2>
                      <p className="businessSub">Role: {agentRole}</p>
                      <p className="businessSub">
                        Business Name: ${businessName}
                      </p>
                    </div>
                  </div>

                  <div className="dataGrid">
                    <div className="dataItem">
                      <div className="dataLabel">Knowledge Source</div>
                      <div className="dataValue">
                        <Globe size={12} /> {websiteUrl}
                      </div>
                    </div>
                    <div className="dataItem">
                      <div className="dataLabel">Voice Model</div>
                      <div className="dataValue">
                        {agentName} (Professional)
                      </div>
                    </div>
                    <div className="dataItem">
                      <div className="dataLabel">Booking Capability</div>
                      <div className="dataValue textGreen">Active</div>
                    </div>
                    <div className="dataItem">
                      <div className="dataLabel">Business Location</div>
                      <div className="dataValue textGreen">
                        {businessCity},{businessState}
                      </div>
                    </div>
                  </div>

                  <div className="demoPlayer">
                    <div className="playIconWrapper">
                      <Mic size={24} />
                    </div>
                    <div style={{ flexGrow: 1 }}>
                      <div
                        className="MDnone"
                        style={{
                          fontSize: "0.75rem",
                          color: "#9ca3af",
                          marginBottom: "0.25rem",
                        }}
                      >
                        Click to Test Agent Voice
                      </div>
                      <div className="equalizer">
                        {[...Array(8)].map((_, i) => (
                          <div
                            key={i}
                            className="bar"
                            style={{
                              animationDelay: `${i * 0.1}s`,
                              height: `${Math.random() * 100}%`,
                            }}
                          ></div>
                        ))}
                      </div>
                    </div>
                    <div
                      className={`talkBadge ${onCall ? "end" : ""} ${buttonDisabled ? "disabled" : ""
                        }`}
                      onClick={!buttonDisabled ? handleTestCall : undefined}
                    >
                      {onCall ? "End Call" : `Talk to ${agentName ?? "Agent"}`}
                    </div>
                  </div>

                  <div
                    className="editRow"
                    onClick={() => setOpenEditPopup(true)}
                  >
                    <button className="editButton">
                      <Edit3 size={12} />
                      Wrong info? Edit Knowledge Base
                    </button>
                    {/* <span>ID: #AG-99281</span> */}
                  </div>
                </div>

                {/* Right: Action - HIDDEN ON MOBILE */}
                <div className="agentSidebar hidden md:flex">
                  <h3 className="sidebarTitle">Agent Status</h3>

                  <div className="warningBox">
                    <AlertTriangle size={20} style={{ flexShrink: 0 }} />
                    <div>
                      <strong>Temporary Hold:</strong> This agent is active but
                      unclaimed. Link it to prevent deletion.
                    </div>
                  </div>

                  <ul className="valueList">
                    <li className="valueItem">
                      <CheckCircle2 size={16} className="textGreen" />
                      <span>
                        24/7 Call Answering{" "}
                        <span className="valueNote">
                          (Value: $3,000/mo human cost)
                        </span>
                      </span>
                    </li>
                    <li className="valueItem">
                      <CheckCircle2 size={16} className="textGreen" />
                      <span>
                        Setup Fee & Integration{" "}
                        <span className="valueNote">($500/mo value)</span>
                      </span>
                    </li>
                    <li className="valueItem">
                      <CheckCircle2 size={16} className="textGreen" />
                      <span>
                        Knowledge Base Training{" "}
                        <span className="valueNote">($500 setup)</span>
                      </span>
                    </li>
                  </ul>

                  <div className="priceBlock">
                    <div className="priceRow">
                      <span>Total Value</span>
                      <span className="strikethrough">$4,000/mo</span>
                    </div>
                    <div className="priceRowMain">
                      <span>Subscription Price</span>
                      <span>$299/mo</span>
                    </div>
                    <div className="priceRowHighlight">
                      <span>7-Day Free Trial Applied</span>
                      <span>Today: $0.00</span>
                    </div>
                  </div>

                  <div className="setupFeeBox">
                    <div className="setupFeeRow">
                      <span className="setupFeeLabel">
                        <Phone size={14} /> Dedicated Phone Line
                      </span>
                      <span className="setupFeePrice">$9.99</span>
                    </div>
                    <p className="setupFeeNote">
                      One-time setup fee required to activate.
                    </p>
                  </div>

                  {/* <button onClick={() => switchStep('checkout')} className="claimButton">
                    Claim Agent for $9.99 <ArrowRight size={20} />
                  </button> */}

                  <p className="guaranteeText">
                    Instant activation. 100% Satisfaction Guarantee.
                  </p>
                </div>
              </div>

              {/* MOBILE STICKY FOOTER ACTION */}
              <div className="stickyMobileContainer">
                <div className="mobileValueStack">
                  <div className="mobileValueRow">
                    <span style={{ color: "#6b7280" }}>
                      Total Value: <span className="strikethrough">$4,000</span>
                    </span>
                    <span className="trialBadge">7-Day Free Trial</span>
                  </div>
                  <div className="mobileSetupRow">
                    <span style={{ fontWeight: "bold", color: "#1f2937" }}>
                      Phone Line Setup:
                    </span>
                    <span className="mobilePrice">$9.99</span>
                  </div>
                </div>
                <button
                  onClick={handleClaimAgent}
                  className={`claimButton ${isActivating ? "disabled" : ""}`}
                  disabled={isActivating}
                >
                  {isActivating ? (
                    <div className="loader"></div>
                  ) : (
                    <>
                      Claim This Agent & Go Live <ArrowRight size={20} />
                    </>
                  )}
                </button>
              </div>
            </div>
          )}

          {/* STEP 2: CHECKOUT (TRIPWIRE) */}
          {currentStep === "checkout" && (
            <div
              className="dashboardContainer"
              style={{ animationName: "slideIn" }}
            >
              <div className="secureCard">
                <div className="secureHeader">
                  <div className="iconBox">
                    <Lock size={24} className="brandPurple" />
                  </div>
                  <div>
                    <h2 className="businessTitle">Secure Claim</h2>
                    <p className="businessSub">
                      Save your agent configuration.
                    </p>
                  </div>
                </div>

                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    switchStep("thankyou");
                  }}
                >
                  <div className="formGroup">
                    <label className="label">Email Address</label>
                    <input
                      type="email"
                      required
                      placeholder="owner@business.com"
                      className="inputStandard"
                    />
                  </div>

                  <div className="formGroup">
                    <label className="label">Card Details</label>
                    <div className="inputWrapper">
                      <input
                        type="text"
                        placeholder="0000 0000 0000 0000"
                        className="inputStandard inputWithIcon"
                      />
                      <CreditCard className="inputIcon" size={20} />
                    </div>
                    <div className="gridCols2 mt-2">
                      <input
                        type="text"
                        placeholder="MM / YY"
                        className="inputStandard"
                      />
                      <input
                        type="text"
                        placeholder="CVC"
                        className="inputStandard"
                      />
                    </div>
                  </div>

                  <div className="summaryBox">
                    <div className="summaryRow">
                      <span>Total Due Now (Setup Fee):</span>
                      <span style={{ fontWeight: "bold" }}>$9.99</span>
                    </div>
                    <div
                      className="summaryRow"
                      style={{ fontSize: "0.75rem", color: "#6b7280" }}
                    >
                      <span>Subscription (Starts in 7 days):</span>
                      <span>$299.00/mo</span>
                    </div>
                  </div>

                  <button type="submit" className="submitButton">
                    Pay $9.99 & Activate
                  </button>
                </form>
              </div>
            </div>
          )}

          {/* STEP 3: THANK YOU */}
          {currentStep === "thankyou" && (
            <div
              className="dashboardContainer"
              style={{ textAlign: "center", paddingTop: "2.5rem" }}
            >
              <div
                style={{
                  width: "5rem",
                  height: "5rem",
                  borderRadius: "9999px",
                  backgroundColor: "#dcfce7",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 1.5rem auto",
                }}
              >
                <Check size={40} className="textGreen" />
              </div>

              <h1
                style={{
                  fontSize: "1.875rem",
                  fontWeight: "bold",
                  marginBottom: "0.5rem",
                }}
              >
                Agent Claimed Successfully!
              </h1>
              <p style={{ color: "#4b5563", marginBottom: "2rem" }}>
                Your deletion timer has been stopped. Your agent is now{" "}
                <strong>Active</strong>.
              </p>

              <div className="secureCard" style={{ textAlign: "left" }}>
                <h3
                  style={{
                    fontWeight: "bold",
                    borderBottom: "1px solid #e5e7eb",
                    paddingBottom: "0.5rem",
                    marginBottom: "1rem",
                  }}
                >
                  Next Steps
                </h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                    }}
                  >
                    <CheckCircle2 className="textGreen" />
                    <span className="strikethrough">Secure Payment</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                    }}
                  >
                    <CheckCircle2 className="textGreen" />
                    <span className="strikethrough">
                      Provision Phone Number
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                      fontWeight: "bold",
                      color: "#6524eb",
                    }}
                  >
                    <div
                      style={{
                        width: "1.5rem",
                        height: "1.5rem",
                        borderRadius: "9999px",
                        backgroundColor: "#6524eb",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "0.75rem",
                      }}
                    >
                      3
                    </div>
                    Connect Google Calendar
                  </div>
                </div>
                <button
                  className="submitButton"
                  style={{ marginTop: "1.5rem", backgroundColor: "#000000" }}
                >
                  Go to Dashboard
                </button>
              </div>
            </div>
          )}
        </main>
      </div>
      {/* --- POPUP OPEN ON CLICK --- */}
      <PopUp
        open={openEditPopup}
        onClose={() => setOpenEditPopup(false)}
        title="Edit Knowledge Base"
      >
        <div className="formdiv">
          <form className="editForm" onSubmit={handleKnowledgeBaseSubmit}
            disabled={kbLoading} style={{ opacity: kbLoading ? 0.6 : 1 }}
          >
            <div className="formGroup">
              <label>Full Name</label>
              <input
                type="text"
                placeholder="Enter your full name"
                value={kbForm.fullName}
                maxLength={50}
                onChange={handleKbFieldChange("fullName")}
                className={kbErrors.fullName ? "inputError" : ""}
              />
              {kbErrors.fullName && (
                <p className="fieldError">{kbErrors.fullName}</p>
              )}
            </div>

            <div className="formGroup">
              <label>Email</label>
              <input
                type="email"
                placeholder="Enter your email"
                value={kbForm.email}
                maxLength={60}
                onChange={handleKbFieldChange("email")}
                className={kbErrors.email ? "inputError" : ""}
              />
              {kbErrors.email && <p className="fieldError">{kbErrors.email}</p>}
            </div>


            <div className="formGroup">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "0.35rem",
                }}
              >
                <label>Google My Business</label>
              </div>


              <GmbAutocomplete
                value={kbForm.gmbLink}
                onChange={(newValue) =>
                  setKbForm((prev) => ({ ...prev, gmbLink: newValue }))
                }
                onSelect={async (place) => {
                  setWebsiteValidated(false);
                  setWebsiteValidating(true);

                  // Step 1: Fetch address + phone + name
                  fetchPlaceDetails(place);

                  // Step 2: Extract Website
                  let websiteFromGmb = place.website || ""; // EMPTY safe

                  // Add https:// if needed
                  if (websiteFromGmb && !/^https?:\/\//i.test(websiteFromGmb)) {
                    websiteFromGmb = "https://" + websiteFromGmb;
                  }

                  // Step 3: Update Form
                  setKbForm((prev) => ({
                    ...prev,
                    gmbLink: place.url,
                    website: websiteFromGmb || prev.website,
                  }));

                  // ❌ If website is EMPTY → Stop here
                  if (!websiteFromGmb) {
                    setWebsiteValidating(false);
                    setSiteMapUrls([]); // clear sitemap
                    return;
                  }

                  // Step 4: Validate website (only if URL exists)
                  const result = await validateWebsite(websiteFromGmb);

                  if (result) {
                    // Step 5: Fetch sitemap
                    const res = await listSiteMap(websiteFromGmb);

                    const filteredUrls = await filterCompanyPages(res.urls);

                    setSiteMapUrls(filteredUrls);
                    setWebsiteValidated(result.valid);
                  }

                  setWebsiteValidating(false);
                }}
              />

              {/* )} */}

              {noGmb && (
                <input
                  type="text"
                  placeholder="Search your business on Google"
                  value={kbForm.gmbLink}
                  onChange={(e) =>
                    setKbForm((prev) => ({ ...prev, gmbLink: e.target.value }))
                  }
                  className="gmb-input"
                />
              )}
            </div>



            <div className="formGroup">
              <label>Business Website</label>

              <input
                type="text"
                placeholder="https://yourwebsite.com"
                value={kbForm.website}
                disabled={websiteValidating}

                onChange={(e) => {
                  let value = e.target.value;
                  if (!value) {
                    setKbForm((prev) => ({ ...prev, website: "" }));
                    setWebsiteValidated(false);
                    setWebsiteValidating(false);
                    setWebsiteTouched(false);

                    return;
                  }

                  // Auto-add https:// if missing
                  if (value && !/^https?:\/\//i.test(value)) {
                    value = "https://" + value;
                  }

                  setKbForm((prev) => ({ ...prev, website: value }));
                  setWebsiteTouched(true);
                  if (domainComplete(value)) {
                    setWebsiteValidating(true);
                    validateWebsite(value).then((res) => {
                      setWebsiteValidated(res.valid);
                      setWebsiteValidating(false);
                    });
                  } else {
                    //  Domain not complete → do NOT show error yet
                    setWebsiteValidated(false);
                    setWebsiteValidating(false);
                  }

                }}
              />

              {websiteValidating && <p className="loadingText">Validating...</p>}

              {!websiteValidating && websiteValidated && (
                <p className="successText">✔ Website verified</p>
              )}

              {!websiteValidating && websiteTouched && !websiteValidated && domainComplete(kbForm.website) && (
                <p className="errorText">❌ Invalid website URL</p>
              )}
            </div>

            <div className="formGroup">
              <label>Business Category</label>
              <select
                value={kbForm.category}
                onChange={(e) =>
                  setKbForm((prev) => ({ ...prev, category: e.target.value }))
                }
              >
                <option value="">Select category</option>
                {businessCategoryTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            {kbError && <p className="errorText">{kbError}</p>}
            {kbSuccess && (
              <p className="successText">Knowledge base updated!</p>
            )}

            <button
              type="submit"
              className="submitBtn"
              disabled={kbLoading ||
                websiteValidating ||
                (domainComplete(kbForm.website) && !websiteValidated)}
              style={{
                opacity: kbLoading ||
                  websiteValidating ||
                  (domainComplete(kbForm.website) && !websiteValidated) ? 0.6 : 1
              }}

            >
              {kbLoading
                ? <div className="button_loader"><Loader size={18} /> Saving</div>
                : websiteValidating
                  ? <div className="button_loader"><Loader size={18} /> Validating website...</div>
                  : "Submit"}
            </button>

          </form>
        </div>
      </PopUp>
      {showPopup && (
        <Alert
          type={popupType}
          message={popupMessage}
          onClose={() => setPopupMessage("")}
        />
      )}
    </>
  );
}
